/**
 * Created by or_p on 3/27/2016.
 */
import React, { PureComponent } from 'react';
import Dialog from 'material-ui/Dialog';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import Lodash from 'lodash';
import * as Colors from 'material-ui/styles/colors';
import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import EbayService from '../../helpers/EbayService';
import Snackbar from 'material-ui/Snackbar';
import { setOpen, setItems } from '../../redux/modules/publishDialog/publishDialog';
import Clipboard from 'clipboard-js';
import InlineButton from '../../../shared/components/InlineButton';
import IconButton from 'material-ui/IconButton';
import platform from 'platform';
import Paper from 'material-ui/Paper';
import { getPublishCode } from 'crazyEditor/core/publish/publish';
import _ from 'lodash';
import {setSnackbar, setReviseError} from 'crazyEditor/redux/modules/publishDialog/publishDialog';
import {isDraft} from 'crazyEditor/redux/modules/element/elementSelectors';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

const classes = require('./PublishDialog.scss');
const rocket = require('./rocket.svg');
const greenMonster = require('./green-monster.svg');
const DIALOG_WIDTH = 870;
const DIALOG_HEIGHT = 670;

// todo, this dialog needs massive cleanup as most of the functionality here is no longer in use.

const DIALOG_STATES = {
  ACTIVE_LISTINGS: 0,
  NEW_LISTING: 1,
  VIEW_CODE: 2
};

const styles = {
  imageColumn: {
    width: 100,
    paddingLeft: 20,
    paddingRight: 0
  },
  titleColumn: {
    width: 370,
    paddingLeft: 15,
    paddingRight: 0,
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  },
  startTimeColumn: {
    width: 130
  },
  tableHeader: {
    fontSize: 16,
    height: 35
  },
  tableRow: {
    color: Colors.grey600,
    fontSize: 16
  },
  code: {
    padding: 20,
    paddingTop: 0,
    paddingBottom: 0,
    width: DIALOG_WIDTH - 20,
    fontSize: 14,
    height: DIALOG_HEIGHT,
    overflowX: 'hidden'
  },
  infoBox: {
    marginLeft: 20,
    marginRight: 20,
    padding: 7,
    display: 'flex',
    alignItems: 'center'
  },
  infoBoxIcon: {
    fontSize: 30,
    marginLeft: 15,
    marginRight: 25
  },
  dialogContent: {
    height: DIALOG_HEIGHT,
    maxHeight: 'calc(100vh - 128px)'
  }
};

const onOpenStateReset = {
  state: DIALOG_STATES.ACTIVE_LISTINGS,
  filter: null
};

@connectWithRouter(
  (state) => ({
    open: state.publishDialog.open,
    firstTime: state.publishDialog.firstTime,
    mobileOptimized: state.template.mobileOptimized,
    ebayConnected: !_.isEmpty(state.accountPage.accounts),
    templateTagSetEnabled: !_.isEmpty(state.templateTagSet),
    templateTagSetInstructions: state.templateTagSet.instructions,
    minifyDisabled: state.templateTagSet.minifyDisabled,
    snackbarProps: state.publishDialog.snackbarProps,
    reviseError: state.publishDialog.reviseError,
    bulkReviseEnabled: state.user.bulkReviseEnabled,
    draft: isDraft(state),
    supportCreateListing: state.general.supportLinks.supportCreateListing
  }),
  {setOpen, setItems, setSnackbar, setReviseError}
)
export default class PublishDialog extends PureComponent {
  state = {
    ...onOpenStateReset,
    refreshing: false,
  };

  componentWillReceiveProps(nextProps) {
    const {open, minifyDisabled, ebayConnected} = this.props;
    if (!open && nextProps.open || !ebayConnected && nextProps.ebayConnected) {
      this.setState({...onOpenStateReset, htmlCode: getPublishCode(false, minifyDisabled).publishCode});
    }
  }


  getBottomButtons() {
    return (
      <div
        style={{position: 'absolute', bottom: 0, width: '100%', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}
      >
        {
          this.copyToClipboardSupported() &&
          <RaisedButton
            style={{marginRight: 20, height: '55px', lineHeight: '55px'}}
            primary
            onClick={this.copyHtmlToClipboard}
            label="copy html code"
          />
        }
      </div>);
  }

  copyHtmlToClipboard = () => {
    window.analytics.track('Copy Code to Clipboard', {
      'Mobile Optimized': this.props.mobileOptimized === true,
    });
    if (!this.copyToClipboardSupported()) {
      this.setState({state: DIALOG_STATES.VIEW_CODE});
    } else {
      const { setSnackbar, templateTagSetEnabled } = this.props;
      Clipboard.copy(this.state.htmlCode);
      setSnackbar({
        snackbarMessage: 'HTML code copied',
        snackbarActionLabel: !templateTagSetEnabled ? 'go to ebay' : null,
        snackbarOpen: true,
        snackbarAction: !templateTagSetEnabled ? () => {
          window.open('http://www.ebay.com/');
        } : null,
      });
    }
  };

  copyToClipboardSupported() {
    return platform.name !== 'Safari';
  }

  reportError = () => {
    const {setReviseError, reviseError} = this.props;
    window.analytics.track('Revise Error', {'Error Message': reviseError, 'Action': 'Report'});
    window.Intercom('showNewMessage',  // eslint-disable-line new-cap
      'Hello Crazylister\n' +
      'I got this error message when I tried to revise a listing:\n' +
      reviseError +
      '\nWhat should I do?'
    );
    setReviseError(null);
  };

  render() {
    const {supportCreateListing, templateTagSetEnabled, templateTagSetInstructions, snackbarProps, setSnackbar, reviseError, setReviseError, draft} = this.props;
    const state = DIALOG_STATES.VIEW_CODE;
    const content = (
      <div
        style={styles.dialogContent}
      >
        <div
          style={{width: '100%', height: 140, backgroundColor: Colors.grey800, position: 'relative'}}
        >
          <div style={{fontSize: 24, color: 'white', paddingTop: 25, paddingLeft: 20}}>HTML code</div>
          <div style={{fontSize: 16, color: Colors.grey500, bottom: 20, left: 20, position: 'absolute'}}>
            {
              templateTagSetEnabled ?
                templateTagSetInstructions :
                'Copy the HTML code below and paste it to the eBay editor and publish your listing.'
            }
          </div>
        </div>
        <Paper
          rounded={false}
          style={{height: 'calc(100% - 260px)', width: 825, margin: 'auto', marginTop: 20, fontSize: 14, overflowX: 'hidden'}}
          zDepth={1}
        >
          <textarea
            value={this.state.htmlCode}
            readOnly
            ref={(ref) => {if (ref) ref.select();}}
            style={{
              display: 'block',
              resize: 'none',
              paddingTop: 15,
              paddingBottom: 15,
              paddingLeft: '2.5%',
              paddingRight: '2.5%',
              margin: 0,
              width: '100%',
              color: Colors.grey700,
              overflow: 'auto',
              height: '100%',
              border: 'none',
              fontFamily: '"Courier New", monospace',
              fontSize: 14
            }}
          />
        </Paper>
        {this.getBottomButtons()}
      </div>
      );

    return (
      <div>
        <Dialog
          style={{lineHeight: 1}}
          open={this.props.open}
          bodyStyle={{ width: DIALOG_WIDTH, maxWidth: DIALOG_WIDTH, padding: 0 }}
          contentStyle={{ width: DIALOG_WIDTH, maxWidth: DIALOG_WIDTH, padding: 0 }}
        >
          {content}
          <IconButton
            onClick={() => {this.props.setOpen(false);}}
            iconStyle={{color: state === DIALOG_STATES.NEW_LISTING ? Colors.grey800 : 'white'}}
            style={{position: 'absolute', right: 5, top: 5}}
          >
            <FontIcon className="material-icons">close</FontIcon>
          </IconButton>
        </Dialog>
        <Snackbar
          open={snackbarProps ? snackbarProps.snackbarOpen : false}
          message={snackbarProps ? snackbarProps.snackbarMessage : undefined}
          action={snackbarProps ? snackbarProps.snackbarActionLabel : undefined}
          autoHideDuration={snackbarProps && snackbarProps.snackbarAutoHide ? 10000 : null}
          onActionClick={snackbarProps ? snackbarProps.snackbarAction : undefined}
          onRequestClose={() => setSnackbar({snackbarOpen: false})}
        />

        { /* TODO this should be a separate component */ }
        <Dialog
          bodyStyle={{padding: 0, fontSize: 16, color: Colors.grey600 }}
          contentStyle={{width: 500}}
          open={!_.isNil(reviseError)}
        >
          <div
            style={{
              fontSize: 24,
              backgroundColor: Colors.red900,
              color: 'white',
              height: 60,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
            <FontIcon style={styles.infoBoxIcon} color={'white'} className="material-icons">error</FontIcon>
            {draft ? 'Save' : 'Revise'} Failed
            <span style={{flexGrow: 1}}></span>
            <IconButton
              onClick={() => {
                window.analytics.track('Revise Error', {'Error Message': reviseError, 'Action': 'Close'});
                setReviseError(null);
              }}
              iconStyle={{color: 'white'}}
            >
              <FontIcon className="material-icons">close</FontIcon>
            </IconButton>
          </div>
          <div style={{margin: 20}}>
            {draft ? 'Save' : 'Revision'} of your item failed due to:
            <div
              style={{
                color: Colors.red900,
                backgroundColor: Colors.red50,
                padding: 20,
                marginTop: 15,
                marginBottom: 15
              }}
            >
              {reviseError}
            </div>
            If you don’t know how to fix this you may <InlineButton onClick={this.reportError} style={{fontSize: 16}}
                                                                    label="ask for help"/><br/>
            Crazylister’s team. We are always happy to help.
          </div>
          <div
            style={{width: '100%', height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <FlatButton
              style={{margin: 20}}
              labelStyle={{color: 'black'}}
              label="report this"
              onClick={this.reportError}
            />
            <FlatButton
              primary
              style={{margin: 20}}
              label={draft ? 'retry save' : 'retry revision'}
              onClick={() => {
                window.analytics.track('Revise Error', {'Error Message': reviseError, 'Action': 'Retry'});
                EbayService.reviseListing();
              }}
            />
          </div>
        </Dialog>
      </div>
    );
  }
}

